"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BancoDoBrasilValidator_1 = __importDefault(require("./Validators/BancoDoBrasilValidator"));
var BanrisulValidator_1 = __importDefault(require("./Validators/BanrisulValidator"));
var BradescoValidator_1 = __importDefault(require("./Validators/BradescoValidator"));
var CitibankValidator_1 = __importDefault(require("./Validators/CitibankValidator"));
var GenericBankAccountValidator_1 = __importDefault(require("./GenericBankAccountValidator"));
var HSBCValidator_1 = __importDefault(require("./Validators/HSBCValidator"));
var ItauValidator_1 = __importDefault(require("./Validators/ItauValidator"));
var SantanderValidator_1 = __importDefault(require("./Validators/SantanderValidator"));
var BankAccountValidatorException_1 = __importDefault(require("./BankAccountValidatorException"));
var BankAccountErrorCodes_1 = require("./BankAccountErrorCodes");
var BankAccountValidator = /** @class */ (function () {
    function BankAccountValidator() {
    }
    BankAccountValidator.validate = function (bankAccount, normalize) {
        if (normalize === void 0) { normalize = false; }
        var errors = [];
        var validator = this.validator(bankAccount.bankNumber);
        if (normalize)
            validator.normalize(bankAccount);
        if (!new GenericBankAccountValidator_1.default().bankNumberIsValid(bankAccount.bankNumber)) {
            errors.push({ message: "Banco inválido", code: BankAccountErrorCodes_1.BankAccountErrorCodes.INVALID_BANK_NUMBER });
        }
        if (!validator.agencyNumberIsValid(bankAccount.agencyNumber)) {
            errors.push({ message: validator.agencyNumberMsgError(), code: BankAccountErrorCodes_1.BankAccountErrorCodes.INVALID_AGENCY_NUMBER });
        }
        if (!validator.agencyCheckNumberIsValid(bankAccount.agencyCheckNumber)) {
            errors.push({ message: validator.agencyCheckNumberMsgError(), code: BankAccountErrorCodes_1.BankAccountErrorCodes.INVALID_AGENCY_CHECK_NUMBER });
        }
        if (!validator.accountNumberIsValid(bankAccount.accountNumber)) {
            errors.push({ message: validator.accountNumberMsgError(), code: BankAccountErrorCodes_1.BankAccountErrorCodes.INVALID_ACCOUNT_NUMBER });
        }
        if (!validator.accountCheckNumberIsValid(bankAccount.accountCheckNumber)) {
            errors.push({ message: "Dígito da conta corrente inválido", code: BankAccountErrorCodes_1.BankAccountErrorCodes.INVALID_ACCOUNT_CHECK_NUMBER });
        }
        if (validator.agencyNumberIsValid(bankAccount.agencyNumber) && validator.agencyCheckNumberIsValid(bankAccount.agencyCheckNumber)) {
            if (!validator.agencyCheckNumberMatch(bankAccount)) {
                errors.push({ message: "Dígito da agência não corresponde ao número da agência preenchido", code: BankAccountErrorCodes_1.BankAccountErrorCodes.AGENCY_CHECK_NUMBER_DONT_MATCH });
            }
        }
        if (validator.accountNumberIsValid(bankAccount.accountNumber) && validator.accountCheckNumberIsValid(bankAccount.accountCheckNumber)) {
            if (!validator.accountCheckNumberMatch(bankAccount)) {
                errors.push({ message: "Dígito da conta não corresponde ao número da conta/agência preenchido", code: BankAccountErrorCodes_1.BankAccountErrorCodes.ACCOUNT_CHECK_NUMBER_DONT_MATCH });
            }
        }
        if (errors.length)
            throw new BankAccountValidatorException_1.default(errors);
        return bankAccount;
    };
    BankAccountValidator.validator = function (bankNumber) {
        switch (bankNumber) {
            case "001":
                return new BancoDoBrasilValidator_1.default();
            case "237":
                return new BradescoValidator_1.default();
            case "341":
                return new ItauValidator_1.default();
            case "033":
                return new SantanderValidator_1.default();
            case "745":
                return new CitibankValidator_1.default();
            case "399":
                return new HSBCValidator_1.default();
            case "041":
                return new BanrisulValidator_1.default();
            default:
                return new GenericBankAccountValidator_1.default();
        }
    };
    return BankAccountValidator;
}());
exports.default = BankAccountValidator;
//# sourceMappingURL=BankAccountValidator.js.map